import { createContext, useContext, type ReactNode } from 'react';
import { useChatWidget, type ChatWidgetState } from './useChatWidget';
import { usePageContext, type PageContext } from './usePageContext';

export interface WidgetContextValue extends ChatWidgetState {
  pageContext: PageContext | null;
}

const WidgetContext = createContext<WidgetContextValue | undefined>(undefined);

export function WidgetProvider({ children }: { children: ReactNode }) {
  const pageContext = usePageContext();
  const widget = useChatWidget(pageContext);

  return <WidgetContext.Provider value={{ ...widget, pageContext }}>{children}</WidgetContext.Provider>;
}

export function useWidgetContext(): WidgetContextValue {
  const ctx = useContext(WidgetContext);
  if (!ctx) {
    throw new Error('useWidgetContext must be used within a WidgetProvider');
  }
  return ctx;
}
